import { switchTransports } from "pages/private/TripSelector/TripSelector.service";
import { postAxios } from "services/api/api.service";
import { apiNames } from "services/api/endpoint.service";
import { SessionStorageItems } from "services/user/user.session.service";
import { IBodyDeleteJourney, IEntryDataDeletion, ITrip } from "../MyTrips.model";
import { deletePSTAVEBooking, deletePSTBooking } from "../MyTrips.service";


/* functions */
export const _cancelDeleteButton = (trip: ITrip) => {
    const informativeTransportsArray = ['metro', 'busLD'];
    const paidTransportsArray = ['cercanias', 'ave', 'taxiVtc'];
    const postpagoTransportsArray = ['cooltra', 'reby', 'metro', 'busLD', 'taxiVtc'];
    const prepagoTransportsArray = ['cercanias', 'ave', 'avant', 'movitaxi'];
  
    const informativeTransports: any[] = trip?.LegList?.Leg.filter((el: any) => {
      let { icon } = switchTransports(el);
      return informativeTransportsArray.includes(icon) && el.isValidLeg !== false;
    });
    const paidTransports: any[] = trip?.LegList?.Leg.filter((el: any) => {
      let { icon } = switchTransports(el);
      return paidTransportsArray.includes(icon) && el.isValidLeg !== false;
    });
    const postpagoTransports: any[] = trip?.LegList?.Leg.filter((el: any) => {
      let { icon } = switchTransports(el);
      return postpagoTransportsArray.includes(icon) && el.isValidLeg !== false;
    });
    const prepagoTransports: any[] = trip?.LegList?.Leg.filter((el: any) => {
      let { icon } = switchTransports(el);
      return prepagoTransportsArray.includes(icon) && el.isValidLeg !== false;
    });
    const isLastPST: boolean = trip?.LegList?.Leg.filter((el: any) => {
      const { icon } = switchTransports(el);
      const isWalk: boolean = (icon == "andar" || icon == "transbordo" || icon == "ingreso");
      return !isWalk && el.isValidLeg !== false;
    }).length === 1;
  
    const returnData = {
      /* informativos */
      countInformativeTransports: (informativeTransports || []).length,
      hasInformativeTransports: (informativeTransports || []).length > 0,
      /* pago */
      hasPaidTransports: (paidTransports || []).length > 0,
      countPaidTransports: (paidTransports || []).length,
      /* prepago */
      hasPrepagoTransports: (prepagoTransports || []).length > 0,
      countPrepagoTransports: (prepagoTransports || []).length,
      /* postpago */
      haspostpagoTransports: (postpagoTransports || []).length > 0,
      countPostpagoTransports: (postpagoTransports || []).length,
      isLastPST
    };
    
    return returnData;
  };

export const getPstToDelete = (detailsSelector: any[], id: number | string) => {
    const pstToDelete = detailsSelector.find((detail: any) => detail.idPst === id);
    return pstToDelete;
}

export const deletePSTCall = (entry: IEntryDataDeletion, callbackOK: Function, callbackKO: Function,) => {
    const { data, orderId, idBooks,noteDriverComment } = entry;
    const body: IBodyDeleteJourney = {
        idx: data?.trip?.idx,
        direction: data?.directionTrip, // 'OUTWARD' | 'RETURN',
        orderId: data?.trip?.orderId || orderId || undefined, //nullable,
        idBooks: idBooks,
        ...(noteDriverComment ? { explanation: noteDriverComment } : {}),
    }
    
    const tripid = data?.idJourney;

    deletePSTBooking({ tripid, body },
        (response: any) => callbackOK(response),
        (err: any) => callbackKO(err)
    );
}


export const deletePSTAVECall = (entry: IEntryDataDeletion, callbackOK: Function, callbackKO: Function) => {
    const { data, orderId, idBooks } = entry;
    const body: IBodyDeleteJourney = {
        idx: data?.trip?.idx,
        direction: data?.directionTrip, // 'OUTWARD' | 'RETURN',
        orderId: data?.trip?.orderId || orderId || undefined, //nullable,
        idBooks: idBooks
    }
    
    const tripid = data?.idJourney;

    deletePSTAVEBooking({ tripid, body },
        (response: any) => callbackOK(response),
        (err: any) => callbackKO(err)
    );
}



/* Refresh */
const refreshStatus = (bookings: any, tarifs: any[], callback: Function, error: Function) => {
    const orderIds: string[] = [];
    tarifs.forEach(item => {
        if (item?.status == "BOOKED" && !!item?.orderId) {
            orderIds.push(item.orderId);
        }
    });
    const uniqueChars = orderIds.filter((element: string, index: number) => orderIds.indexOf(element) === index);
    RefreshTripsStatus(bookings, uniqueChars,
        (data: any) => callback(data),
        (err: any) => error(err)
    );
}
export const cancelledRecently = () => {
    try {
        const cancelationDate = sessionStorage.getItem(SessionStorageItems.RAAS_PST_CANCELLED_RECENTLY) || '';
        if (!!cancelationDate) {
            const currentDatetime: any = new Date();
            const cancelationDatetime: any = new Date(cancelationDate);
            const diff = currentDatetime - cancelationDatetime;
            const hours = diff / 1000 / 60 / 60;
            const minutes = diff / 1000 / 60 % 60;
            return hours < 1 && minutes < 5;
        }
        return false;
    } catch (error) {
        return false;
    }
}
export async function RefreshTripsStatus(bookings: any, idsArray: string[], callback: Function, errorCallback: Function) {
    const arrayCalls = idsArray.map((id: string) => postAxios(apiNames.BKING, true, `/journeys/refresh/${id}`, {}));
    await Promise.all(arrayCalls) //CONCURRENTE
        .then((data: any) => {
            const bookingsUpdated = updateBookingStatus(bookings, data);
            callback(bookingsUpdated);
        }).catch((error: any) => {
            errorCallback(error)
        })
}

export function updateBookingStatus(bookings: any, response: any) {
    try {
        (response || []).forEach((res: any) => {
            (bookings?.outwardJourney?.selectedTariff || []).forEach((tariff: any) => {
                if (res?.data?.orderId === tariff.orderId) {
                    (res?.data?.items || []).forEach((item: any) => {
                        (tariff?.tickets || []).forEach((ticket: any) => {
                            if (ticket.idBook === item.idBook && ticket.status !== item.status) {
                                ticket.status = item.status;
                                tariff.status = item.status;
                            }
                        });
                    })
                }
            });
        });
    } catch (error) {
        console.log('Error en updateBookingStatus', error);
    }
    return bookings;

}